export const defaultItems = []
export const defaultLoading = false
export const defaultTotalSize = null

export default {
  items: defaultItems,
  loading: defaultLoading,
  totalSize: defaultTotalSize
}
